/**
 * Turns the first letter of a string to upper case, the remaining
 * string is remaining unchanged.
 */
export const capitalizeFirstLetter = (input: string) =>
  `${input.charAt(0).toUpperCase()}${input.slice(1)}`;
